import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { UtilitiesService } from '../../services/utilities.service';
import { fromEvent } from 'rxjs';
import { DialogService } from '../dialog/dialog.service';
import { BaseService } from '../../shared/services/base.service';
import { TextToSpeechComponent } from '../text-to-speech/text-to-speech.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { PreferenceService } from '../../shared/services/preference.service';
import { Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { HttpHeaders } from '@angular/common/http';
import { LoaderService } from '../../services/loader.service';
import { AppService } from '../../shared/services/app.service';
import { QrCodeScannerComponent } from '../qr-code-reader/qr-code-scanner.component';
import { AutoClickComponentComponent } from '../file-uploader/auto-click-component/auto-click-component.component';
import { UtilService } from '../../services/util.service';
import { AuthenticationService } from '../../shared/services/authentication.service';

@Component({
  selector: 'app-complex-search',
  templateUrl: './complex-search.component.html',
  styleUrls: ['./complex-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ComplexSearchComponent implements OnInit {
  @Input() config: any;
  @Output() onFilterChange: EventEmitter<any> = new EventEmitter();
  filterKey: string = '';
  setBarcode: boolean = false;
  combinedCode = null
  lastKeyTime = Date.now();
  keyEvent: any;
  finalFilterVal: string = "";
  proxy_key: any;
  headerInfo: any;
  filter = "test";

  @ViewChildren('input') vc;  //using in data grid
  serVal: any;
  enable_uhid_search_in_uppercase: any;
  constructor(
    private utilitiesService: UtilitiesService,
    public service: DialogService,
    public baseService: BaseService,
    private alert: AlertsService,
    private cdRef: ChangeDetectorRef,
    public preferencesService: PreferenceService,
    public router: Router,
    public loader: LoaderService,
    private auth: AuthenticationService,
    public dialogService: DialogService,
    public appService: AppService,
    public utilService: UtilService
  ) {
    this.serVal = this.utilitiesService.documentClickedTarget
      .subscribe(target => {
        this.onClick(target)
      })
    // document.addEventListener('click', (args) => this.onClick(args));
    this.headerInfo = this.appService.getAppHeader();
  }

  ngOnInit() {
    const barcodeScanner = fromEvent(document, 'keypress');
    this.keyEvent = barcodeScanner.subscribe(event => {
      if (this?.config?.barcode_config?.performActionOnScan != true && this?.config?.barcodeConfig != undefined && this?.config?.barcodeConfig?.barcodeScan != undefined && this?.config?.barcodeConfig?.barcodeScan && this?.config?.barcode_config != undefined && this?.config?.barcode_config && !this.config.filterOpenStatus && document.activeElement['id'] != 'search-menu-text' && document.activeElement['id'] != 'complex-search-input' && document.activeElement.className != 'form-control input-element-main-search' && document.activeElement['id'] != 'search' && document.getElementsByTagName('app-dialog').length === 0) {
        console.log("keyEvent ==>", event);
        console.log("config ==>", this.config);
        (document.activeElement as HTMLElement).blur();
        if (event['key'] === 'Enter' && this.combinedCode) {
          console.log("At enter");
          this.filterKey = this.combinedCode;
          this.combinedCode = "";
          this.config.searchField = this.config.complex_search.find(data => data.key === this.config.barcode_config.key);
          this.onFilterChange.emit({ "key": this.config.searchField.key, "value": this.filterKey.trim(), "barcode": this.setBarcode });
          console.log("val is as follow", this.combinedCode);
        } else if (event['key'] !== 'Enter') {
          console.log("At key");
          const currentTime = Date.now();
          this.setBarcode = true;
          if (this.combinedCode === null) {
            this.combinedCode = event['key'];
          } else {
            this.combinedCode = this.combinedCode + event['key'];
          }
          // this.combinedCode = currentTime - this.lastKeyTime > 40 && this.combinedCode.length != 1 ? null : this.combinedCode;
          this.lastKeyTime = currentTime;
        }
        this.cdRef.detectChanges();
      }
    });

    console.log("Search Config ", this.config);
    if (this.config != undefined && this.config.complex_search == undefined && this.config.setSearchPopup == undefined) {
      this.config.setSearchPopup = false;
    }
    if (this.config != undefined && this.config.complex_search != undefined && this.config.complex_search.length > 0) {
      if (this.config.localStorageData && this.config.localStorageData.complex_search) {
        this.config.searchField = this.config.localStorageData.complex_search;
        if (this.config.searchField.value != undefined && this.config.searchField.value != "") {
          this.filterKey = this.config.searchField.value;
        }
      } else if (this.config.searchColumns == undefined) {
        this.config.searchField = this.config.complex_search[0];
        if (this.config.searchField.value != undefined && this.config.searchField.value != "") {
          this.filterKey = this.config.searchField.value;
        }
      } else {
        this.config.searchField = this.config.complex_search.find(val => {
          return val.key == this.config.searchColumns;
        });
        if (this.config.search != undefined)
          this.filterKey = this.config.search;
      }
      if (this.config.searchField.datasource != undefined) {
        this.config.inputSearch = true;
      } else {
        this.config.inputSearch = false;
      }
      if (this.config.APIresource && this.config.APIresource.datasource && this.config.APIresource.datasource.search) {
        this.filterKey = this.config.APIresource?.datasource?.search ? this.config.APIresource.datasource.search : '';
        this.config.searchField = this.config.APIresource?.datasource?.search_columns ? this.config.complex_search.find(val => { return val.key == this.config.APIresource?.datasource?.search_columns }) : {};
      }
    } else {
      this.config.searchField = '';
    }
  }
  ngOnDestroy() {
    if (this.serVal != undefined)
      this.serVal.unsubscribe();
    if (this.keyEvent != undefined)
      this.keyEvent.unsubscribe();
  }
  public filterValidate(e) {
    var invalidChars = ["%"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  //set Barcode val
  setBarcodeVal() {
    if (this.config.barcode_config != undefined && this.setBarcode) {
      this.config.searchField = this.config.complex_search.find(data => data.key === this.config.barcode_config.key);

    }
  }
  public onFilter(event) {
    // event.stopPropagation();
    // event.preventDefault();
    // this.combinedCode = "";
    if (this.config && this.config.complex_search == undefined) {
      var valid = this.filterValidate(event);
      if (valid) {
        if (event.keyCode === 13) {
          this.finalFilterVal = event.target.value.trim();
          this.onFilterChange.emit(event.target.value.trim());
        }
      }
    } else {
      this.config.setSearchPopup = false;
      var valid = this.filterValidate(event);
      if (valid) {
        // this.setBarcodeVal();
        if (event.keyCode === 13) {
          this.enable_uhid_search_in_uppercase = this.appService?.getAccountConfigValue("enable_uhid_search_in_uppercase")
          if (this.enable_uhid_search_in_uppercase != undefined && this.enable_uhid_search_in_uppercase != "") {
            if (this.config != undefined && this.config.searchField != undefined && this.config.searchField.key != undefined && this.config.searchField.key == "uhId" && event.target != undefined && event.target.value != "") {
              event.target.value = event.target.value.toUpperCase()
            }
          }
          this.finalFilterVal = event.target.value.trim();
          this.emitFilterChange(this.config.searchField.key, event.target.value, this.config.searchField);
          //initializing back to the keyboard val
          this.setBarcode = false;
        }
      }
    }
  }

  hasQrCodeScanner() {
    let popobj = { data: {}, title: 'QR Code Scanner', size: DialogModalSize.Sm };
    this.dialogService.open(QrCodeScannerComponent, popobj).afterClosed.subscribe(
      response => {
        if (response) {
          let key = ""
          if (this.config.searchField.key != undefined)
            key = this.config.searchField.key;
          this.emitFilterChange(key, JSON.stringify(response));
        }
      });
  }

  emitFilterChange(key, value, searchObj?) {
    if (this.enable_uhid_search_in_uppercase != undefined && this.enable_uhid_search_in_uppercase != "") {
      if (key != undefined && key != "" && key == "uhId" && value != "" && value != undefined) {
        value = value.toUpperCase()
      }
    }
    if (value && value.includes("<?xml")) {
      value = JSON.stringify(this.baseService.utilService.parseQrCodeString(value));
    }
    if (this.checkType(value) == 'object') {
      let _value = this.changeJsonNormal(value, this.config.searchField);
      if (_value && _value.key) {
        key = _value.key;
      }
      if (_value && _value.label) {
        this.config.searchField.label = _value.label
      }
      value = _value.value;
      this.filterKey = value;
    }
    if (this.config.searchField.label != undefined) {
      this.baseService.asyncLanguageProcess(this.config.searchField.label).then((label) => {
        if (!label) {
          label = "Search";
        }
        value = this.applyPrefixLength(value);

        this.onFilterChange.emit({ "label": label, "key": key, "value": value.trim(), "barcode": this.setBarcode, searchObj: searchObj != undefined ? searchObj : {}, "proxy_key": this.proxy_key ? this.proxy_key : "" });
      });
    } else {
      value = this.applyPrefixLength(value);
      this.onFilterChange.emit({ "key": key, "value": value.trim(), "barcode": this.setBarcode, searchObj: searchObj != undefined ? searchObj : {}, "proxy_key": this.proxy_key ? this.proxy_key : "" });
    }
  }
  handleKeyEnter(event) {
    event.preventDefault();
  }

  applyPrefixLength(text) {
    if (this.config?.searchField?.search_length != undefined) {
      if (text && text.length < this.config?.searchField?.search_length) {
        var enteredInput = "";
        if (this.config?.searchField?.value != undefined && this.config?.searchField?.value) {//prefix is defined
          enteredInput = text.replace(this.config?.searchField?.value, "");
          if (enteredInput != "") {
            let newInput = this.utilService.padWithLeadingZeros(enteredInput, (this.config?.searchField?.search_length - this.config?.searchField?.value.length))
            if (newInput) {
              text = this.config?.searchField?.value + newInput;
              this.filterKey = text;
            }
          }
        } else {
          let newInput = this.utilService.padWithLeadingZeros(text, (this.config?.searchField?.search_length - this.config?.searchField?.value.length))
          if (newInput) {
            text = newInput;
            this.filterKey = text;
          }
        }
      }
    }
    return text;
  }

  clearComplexSearch() {
    if (this.config.complex_search.length > 0) {
      if (this.config.localStorageData && this.config.localStorageData.complex_search) {
        this.config.searchField = this.config.localStorageData.complex_search;
      } else
        this.config.searchField = this.config.complex_search[0];
      if (this.config.searchField.value != undefined && this.config.searchField.value != "") {
        this.filterKey = this.config.searchField.value;
      } else {
        this.filterKey = '';
      }
    } else {
      this.config.searchField = '';
      this.filterKey = '';
    }
    if (this.config.searchField.datasource != undefined) {
      this.config.inputSearch = true;
    } else {
      this.config.inputSearch = false;
    }
    this.config.setSearchPopup = true;
    //below line commented for search changes
    //this.filterKey = '';
    // this.config.inputSearch = false;

    // this.onFilterChange.emit(this.filterKey.trim());
  }
  public onFilterClick(event) {
    if (this.config && this.config.complex_search == undefined) {
      this.onFilterChange.emit(event.trim());
    } else {
      if (!this.config.setSearchPopup)
        this.config.setSearchPopup = true;
      else
        this.config.setSearchPopup = false;
      // this.searchFields(event);
      // var valid = this.filterValidate(event);
      // if (valid && event != '' && event != undefined) {
      //     this.onFilterChange.emit({"key": this.config.searchField.key, "value":event});
      // }
    }
  }
  searchFields(event) {
    if (this.config && this.config.complex_search != undefined && !this.config.setSearchPopup && event.target.value == '') {
      this.config.setSearchPopup = true;
    } else {
      this.config.setSearchPopup = false;
    }
  }
  onSearchKey(event) {
    // event.stopPropagation();
    // event.preventDefault();
    if (event.target.value == '') {
      this.onSearchClicked('');
      this.onFilterChange.emit('');
      //this.config.setSearchPopup = true;
    }
    //console.log("Event is ", event.target.value);
  }

  checkType(text: any) {
    try {
      let type = typeof JSON.parse(text)
      return type;
    } catch (e) {
      return "string";
    }
  }

  changeJsonNormal(value, key) {
    let _value = JSON.parse(value);
    let _index
    if (key) {
      _index = Object.keys(_value).map(x => this.config.complex_search.findIndex(y => y.key == x));
    }
    if (!_value.hasOwnProperty("hid")) {
      if (_index && _index.length) {
        return { ...this.config.complex_search[_index.filter(x => x != -1)[0]], ...{ value: JSON.parse(value)[this.config.complex_search[_index.filter(x => x != -1)[0]].key] } }
      } else {
        return { value: JSON.parse(value)[key.key] }
      }
    } else if (_value.hasOwnProperty("hid")) {
      if (this.config.complex_search.filter(x => x.key.includes("abdm")).length) {
        return { ...this.config.complex_search.find(x => x.key.includes("abdm")), ...{ value: JSON.parse(value)["hid"] } }
      } else {
        return { ...this.config.complex_search.find(x => x.key.includes("tag")), ...{ value: JSON.parse(value)["hid"] } }
      }
    } else {
      let rightKey = Object.keys(JSON.parse(value)).filter(x => x != "code_type").join(",");
      this.alert.info("please select " + rightKey + " to scan");
      return { value: "" };
    }
  }

  onSearchClicked(search) {
    //console.log("Search is ", search);
    this.config.setSearchPopup = false;
    if (search != '') {
      this.config.searchField = search;
      if (search.value != undefined && search.value != "") {
        this.filterKey = search.value;
      } else {
        this.filterKey = '';
      }
      // this.config.complexSearchClick = true;
    } else {
      this.filterKey = '';
    }
    if (this.config.searchField.datasource != undefined) {
      this.config.inputSearch = true;
    } else {
      this.config.inputSearch = false;
    }
    //only fire fi there is not default value is in default search, 
    //it means it is prefix and don't need to be search only if user adds some values
    if (this.filterKey && !(search.value != undefined && search.value != "")) {
      this.emitFilterChange(search.key, this.filterKey, search);
    }
    this.cdRef.detectChanges();
  }
  settingUserInfo(e) {
    this.config.inputSearch = false;
    let value = '';
    let key = ''
    if (this.config.searchField.value_key != undefined && this.config.searchField.value_key != '') {
      key = this.config.searchField.value_key;
      //this.config.searchField.key = key;
      value = e[this.config.searchField.value_key];
    } else {
      key = this.config.searchField.key;
      value = e[this.config.searchField.key];
    }
    this.filterKey = e[this.config.searchField.key];
    const twoStepSearchObj = this.config?.complex_search?.find(item => item.twoStepSearch);
    if (twoStepSearchObj) {
      const { key: searchKey, readValueKey, displayName } = twoStepSearchObj.twoStepSearch;
      key = searchKey;
      value = e[readValueKey];
      this.filterKey = e[displayName];
    }

    if (this.config.searchField.proxy_key != undefined && this.config.searchField.proxy_key != '') {
      this.proxy_key = e[this.config.searchField.proxy_key];
    }
    if (this.config.searchField.set_key != undefined)
      key = this.config.searchField.set_key;
    this.emitFilterChange(key, value, this.config.searchField);
  }
  onClick(args: any) {
    if ((args.target.tagName == 'A' || args.target.tagName == 'I') && (args.target.className.includes('complex-search-pill-close') || args.target.className.includes('fa fa-angle-down'))) {
    } else {
      if (this.config.setSearchPopup) {
        this.config.setSearchPopup = false;
        this.cdRef.detectChanges();
      }
    }
  }

  textToSpeech(key) {
    let popobj = { data: { 'speech': true, 'searchElement': true }, size: DialogModalSize.Sm, 'title': 'vtotext' };
    this.service.open(TextToSpeechComponent, popobj).afterClosed.subscribe((result: any) => {
      if (result) {
        if (this.config && this.config.complex_search) {
          key = "complex-search-input search_value_input";
        }
        let value_key: any = document.getElementById(key)
        value_key.value = result
        value_key.click();
        this.filterKey = result;
        let e = { 'target': { "value": result }, "keyCode": 13 }
        this.onFilter(e);
      }
    })
  }

  getContactInfo(key) {
    this.loader.showSpinner();
    this.baseService.get("GET_PATIENT_MOBILE_CONVOX", `agentid:${this.auth.getCurrentUser().login_id},action:FETCHCUSTOMERDETAILS,refno:123456789`, "convox_patient_mobile", "facility-management").subscribe((res: any) => {
      if (res.resource && res.resource.length) {
        // let value_key: any = document.getElementById(key)
        // value_key.value = res.resource[0].telecom;
        // value_key.click();
        this.filterKey = res.resource[0].telecom;
        let e = { 'target': { "value": res.resource[0].telecom }, "keyCode": 13 }
        this.onFilter(e);
      } else {
        this.alert.error(res.message);
      }
      this.loader.hideSpinner();
    })
  }

  redirect(info) {
    this.router.navigate([info.url], { queryParams: { returnUrl: this.router.url, key: info.base, uhId: this.filterKey } });
  }

  getConvoxConfig() {
    return this.baseService.rolePermissionService.checkAccessPermission("GET_PATIENT_MOBILE_CONVOX", "convox_patient_mobile", "facility-management") && this.appService.getAccountConfigValue("convox_patient_mobile");
  }


  //barcode works from here
  // combinedCode = null
  // lastKeyTime = Date.now();
  // @HostListener('document:keypress', ['$event'])
  // keyEvent(event: KeyboardEvent) {
  //   if (this.config.barcode_config != undefined && this.config.barcode_config && !this.config.filterOpenStatus && document.activeElement['id'] != 'search-menu-text' && document.activeElement['id'] != 'complex-search-input') {
  //     (document.activeElement as HTMLElement).blur();
  //     if (event.key === 'Enter' && this.combinedCode) {
  //       console.log("At enter");
  //       this.filterKey = this.combinedCode;
  //       this.combinedCode = "";
  //       this.config.searchField = this.config.complex_search.find(data => data.key === this.config.barcode_config.key);
  //       this.onFilterChange.emit({ "key": this.config.searchField.key, "value": this.filterKey, "barcode": this.setBarcode });
  //       console.log("val is as follow", this.combinedCode);
  //     } else if (event.key !== 'Enter') {
  //       console.log("At key");
  //       const currentTime = Date.now();
  //       this.setBarcode = true;
  //       if (this.combinedCode === null) {
  //         this.combinedCode = event.key;
  //       } else {
  //         this.combinedCode = this.combinedCode + event.key;
  //       }
  //       // this.combinedCode = currentTime - this.lastKeyTime > 40 && this.combinedCode.length != 1 ? null : this.combinedCode;
  //       this.lastKeyTime = currentTime;
  //     }
  //   }

  // }

  facerecognition() {
    let obj = { data: { "send_base64_data": true }, title: 'Face Recognition', size: DialogModalSize.Md, className: "modal-md" };
    this.dialogService.open(AutoClickComponentComponent, obj).afterClosed.subscribe(
      response => {
        if (response) {
          console.log(response)
          this.loader.showSpinner();
          this.onSearchClicked(response.selectedSearch)
          this.filterKey = response.filterKey
          this.cdRef.detectChanges();
          this.onFilterChange.emit({ "key": "uhId", "value": this.filterKey, "barcode": this.setBarcode });
          this.loader.hideSpinner();
        }
      }
    );
  }
}
